import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Advait Tour and Travels - Best Taxi Service in Ludhiana | Ludhiana to Delhi Taxi | 24/7 Cab Booking | Call +91-79986-66660',
  description = 'Book premium taxi services with Advait Tour and Travels. Ludhiana to Delhi taxi, Delhi to Ludhiana cab, Chandigarh to Haridwar one way, book taxi city to city. Best cab service in Ludhiana. 24/7 airport taxi, Force Urbania, Tempo Traveller, local cabs, and outstation packages. Call +91-79986-66660 for instant booking.',
  keywords = 'advait tour and travels, ludhiana to delhi taxi, delhi to ludhiana cab, chandigarh to haridwar one way, book taxi city to city, best cab service in ludhiana, taxi service Ludhiana, cab booking Ludhiana, airport taxi Ludhiana, Force Urbania booking, Tempo Traveller Ludhiana, Ludhiana to Chandigarh taxi, Ludhiana to Delhi cab fare, outstation taxi, wedding car rental, corporate cab service, 7998666660, 79986-66660, advait tour and travels ludhiana, intercity taxi booking',
  ogTitle,
  ogDescription,
  ogImage = '/assets/images/image-1768073645428.png',
  ogUrl,
  canonicalUrl,
  structuredData,
  noIndex = false,
}) => {
  const siteUrl = window.location?.origin;
  const currentUrl = canonicalUrl || window.location?.href;
  const finalOgTitle = ogTitle || title;
  const finalOgDescription = ogDescription || description;
  const finalOgImage = ogImage?.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;
  const finalOgUrl = ogUrl || currentUrl;

  // Default structured data for better SEO
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Advait Tour and Travels",
    "description": description,
    "url": siteUrl,
    "telephone": "+91-79986-66660",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Ludhiana",
      "addressRegion": "Punjab",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "30.9010",
      "longitude": "75.8573"
    },
    "priceRange": "₹₹",
    "openingHours": "Mo-Su 00:00-23:59",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "500"
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      
      {/* Performance & Optimization Meta Tags */}
      <meta httpEquiv="x-dns-prefetch-control" content="on" />
      <meta name="format-detection" content="telephone=yes" />
      <meta name="HandheldFriendly" content="true" />
      <meta name="MobileOptimized" content="width" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalOgUrl} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Advait Tour and Travels" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={finalOgUrl} />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={finalOgImage} />
      
      {/* Additional SEO Tags */}
      <meta name="author" content="Advait Tour and Travels" />
      <meta name="geo.region" content="IN-PB" />
      <meta name="geo.placename" content="Ludhiana" />
      <meta name="geo.position" content="30.9010;75.8573" />
      <meta name="ICBM" content="30.9010, 75.8573" />
      <meta name="contact" content="+91-79986-66660" />
      <meta name="telephone" content="+91-79986-66660" />
      
      {/* Language & Locale */}
      <meta httpEquiv="content-language" content="en-IN" />
      <link rel="alternate" hrefLang="en-IN" href={currentUrl} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;